import axios from "axios";

const BASE_URL = process.env.REACT_APP_BASE_URL;

export const fetchWorkoutHistory = async (userId) => {
  try {
    const response = await axios.get(
      `${BASE_URL}/user-dashboard/api/user/workouts`,
      { withCredentials: true }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching workout history:", error);
    return [];
  }
};

export const fetchPersonalStats = async (userId) => {
  try {
    const response = await axios.get(
      `${BASE_URL}/user-dashboard/api/user/personal-stats`,
      { withCredentials: true }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching personal stats:", error);
    return null;
  }
};

export const updatePersonalStat = async (userId, statName, newValue) => {
  console.log("Updating personal stat:", { userId, statName, newValue });
  try {
    const response = await axios.put(
      `${BASE_URL}/user-dashboard/api/user/personal-stats`,
      {
        statName,
        newValue,
      },
      { withCredentials: true }
    );

    console.log("Stat updated successfully:", response.data);
    return response.data;
  } catch (error) {
    console.error("Error updating personal stat:", error);
    throw error;
  }
};

export const addWorkoutProgress = async (userId, workoutData) => {
  try {
    const response = await axios.post(
      `${BASE_URL}/user-dashboard/api/user/workout-progress`,
      workoutData,
      { withCredentials: true }
    );
    console.log("Workout progress added:", response.data);
    return response.data;
  } catch (error) {
    console.error("Error adding workout progress:", error);
    throw error;
  }
};
